import { render, staticRenderFns } from "./Alerts.vue?vue&type=template&id=cec69356&"
import script from "./Alerts.vue?vue&type=script&lang=js&"
export * from "./Alerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cec69356')) {
      api.createRecord('cec69356', component.options)
    } else {
      api.reload('cec69356', component.options)
    }
    module.hot.accept("./Alerts.vue?vue&type=template&id=cec69356&", function () {
      api.rerender('cec69356', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/service/Alerts.vue"
export default component.exports